const jobs = {
  bulk: {

    table: {
      direction: {
        distribute: 'לבית הספר',
        collect: 'מבית הספר',
        both: 'לבית הספר & מבית הספר',
      },

    },

    direction: {
      to: 'לבית הספר',
      from: 'מבית הספר',
      both: 'לבית הספר & מבית הספר',
    },

    form: {
      information: {
        details: {
          fields: {
            fromHour: 'תחילת בית ספר ב',
            toHour: 'סיום בית ספר ב-',
            shift: 'שעות בית ספר',
            from: 'בית',
            to: 'בית ספר',
          },
        },
        locations: {
          header: 'בית ספר',
          fields: {
            locations: 'בחר בית ספר'
          }
        },
      },
    },
  },

  forms: {
    information: {
      passengers: {
        header: 'מידע אישי',
        label: 'בחר תלמידים'
      },
    }
  }
};

export default jobs;
